<template>
  <!-- 途径网点--PassingThroughBranches -->
  <myDialog
    :diaWidth="diaWidth"
    :dialogTitle="dialogTitle"
    :isShowDialog="isShowDialog"
    @handleCloseDia="handleCloseDia"
    @diaCancelBtn="diaCancelBtn"
    @diaConfirmBtn="diaConfirmBtn('dialogFormRef')"
  >
    <div class="glo_dialogForm">
      <div class="container">
        <!-- 按钮列表 -->
        <div class="glo_btnList" ref="btnList">
          <div class="glo_btnList_left">
            <el-button class="glo_btnItems" @click="add">添加网点</el-button>
            <el-button class="glo_btnItems" @click="edit">修改</el-button>
            <el-button class="glo_btnItems" @click="yichu">移除</el-button>
            <el-button class="glo_btnItems" @click="moveUp">上移</el-button>
            <el-button class="glo_btnItems" @click="moveDown">下移</el-button>
          </div>
        </div>
        <!-- 表格 -->
        <mytable
          ref="mytable"
          :tableHeigth="'500px'"
          :tableData="tableData"
          :myTableHeard="myTableHeard"
          :isShowOperate="isShowOperate"
          :isShowMoreOperate="isShowMoreOperate"
          :btnsList="btnsList"
          :btnsMoreList="btnsMoreList"
          :Operatewidth="Operatewidth"
          @handleSelectionChange="handleSelectionChange"
        ></mytable>
      </div>

      <myDialog
        :diaWidth="'400px'"
        :dialogTitle="detailTitle"
        :isAppend="true"
        :isShowDialog="isShowDetailDia"
        @handleCloseDia="closeDetailEditForm"
        @diaCancelBtn="closeDetailEditForm"
        @diaConfirmBtn="saveDetailBtn"
      >
        <div class="glo_dialogForm">
          <el-form
            v-if="isShowDetailDia"
            class="diaForm"
            ref="dialogFormRef"
            :model="detailForm"
            label-width="120px"
            :rules="rulesForm"
          >
            <el-form-item
              class="dialogFormItems"
              label="到达网点"
              prop="deptId"
              required
            >
              <el-select
                v-model="detailForm.deptId"
                placeholder="请选择"
                clearable
                @change="changeDept"
                filterable
              >
                <el-option
                  v-for="item in businessDepts"
                  :key="item.deptId"
                  :label="item.deptName"
                  :value="item.deptId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              class="dialogFormItems"
              label="操作类型"
              prop="unLoadOperationType"
              required
            >
              <el-select
                v-model="detailForm.unLoadOperationType"
                placeholder="请选择"
                clearable
                @change="changeUnLoadOperationType"
                filterable
              >
                <el-option
                  v-for="item in operationTypes"
                  :key="item.state"
                  :label="item.stateShow"
                  :value="item.state"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              class="dialogFormItemsTime"
              label="预计到达时间"
              prop="planArrivalTime"
              required
            >
              <el-date-picker
                v-model="detailForm.planArrivalTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择日期时间"
              />
            </el-form-item>
            <el-form-item
              class="dislogFormTextarea"
              prop="remarks"
              label="备注"
            >
              <el-input
                type="textarea"
                rows="2"
                v-model="detailForm.remarks"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </myDialog>
    </div>
  </myDialog>
</template>

<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import myDialog from "@/components/Dialog.vue";
import mytable from "@/components/table/table.vue";
export default {
  mixins: [tableListNew],
  components: {
    myDialog,
    mytable,
  },
  props: {
    dispatchId: {},
  },
  data() {
    return {
      isShowDialog: false,
      dialogTitle: "途径网点",
      diaWidth: "80%",
      pageGroupName: "PassingThroughBranches", //  页面标识
      reportFiledsNumber: "admin_dispatch_onway_dept_list_v5", // 动态 条件、表头
      isShowOperate: false, //是否显示右边操作
      isShowMoreOperate: false, //是否显示右边更多操作
      // 表格右边操作按钮
      btnsList: [],
      // 表格右边更多的操作按钮
      btnsMoreList: [],
      Operatewidth: "220px", //操作列的列宽
      // queryCondditionDatas: [
      //   {
      //     conditonKey: "dispatchId",
      //     conditonVal: '1',
      //   },
      // ],
      // 不立马查询
      immediate: false,
      businessDepts: [], // 网点
      operationTypes: [], // 操作类型
      detailTitle: "添加网点",
      isShowDetailDia: false,
      detailForm: {
        tableId: "",
        deptName: "",
        deptId: "",
        unLoadOperationType: "",
        unLoadOperationTypeShow: "",
        planArrivalTime: "",
        remarks: "",
      },
      rulesForm: {
        deptId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        unLoadOperationType: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        planArrivalTime: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      },
    };
  },
  watch: {
    isShowDialog(n) {
      if (n) {
        // 手动查询
        this.getData({ dispatchId: this.dispatchId });
        this.getOperationTypes();
        this.getBusinessDepts();
      } else {
        this.$emit("close");
      }
    },
  },
  methods: {
    async saveDetailBtn() {
      await this.$API.setOnwayDept({
        dispatchId: this.dispatchId,
        deptInfos: [
          {
            ...this.detailForm,
            operationType: this.detailForm.tableId ? "UPDATE" : "ADD",
            sort: this.tableData.length,
          },
        ],
      });
      await this.getData({ dispatchId: this.dispatchId });
      this.closeDetailEditForm2();
    },
    closeDetailEditForm2() {
      this.isShowDetailDia = false;
      this.detailForm = {
        tableId: "",
        deptName: "",
        deptId: "",
        unLoadOperationType: "",
        unLoadOperationTypeShow: "",
        planArrivalTime: "",
        remarks: "",
      };
    },
    closeDetailEditForm() {
      this.closeDetailEditForm2();
      //this.tableData = []
    },
    // 获取营业网点
    async getBusinessDepts() {
      const data = await this.$API.runListReport({
        number: "business_dept_down_list",
      });
      this.businessDepts = data;
    },
    // 获取操作类型
    async getOperationTypes() {
      const data = await this.$API.runListReport({
        number: "down_list_dispatch_onway_dept_operation_type_v5",
      });
      this.operationTypes = data;
    },
    // 新增
    add() {
      this.isShowDetailDia = true;
      // let obj = {
      //   tableId: null,
      //   sort: '',
      //   deptName: '',
      //   deptId: '',
      //   unLoadOperationType: '',
      //   unLoadOperationTypeShow: '',
      //   planArrivalTime: '',
      //   actualArrivalTime: '',
      //   arrivalUserName: '',
      //   departureTime: '',
      //   remarks: ''
      // }
      // this.tableData.push(obj)
    },
    // 修改
    edit(row) {
      if (this.selectTableData.length == 0) {
        this.$message.warning("请选择一条记录进行操作");
        return;
      }
      this.detailTitle = "修改网点";
      this.detailForm = {
        ...this.selectTableData[0],
      };
      this.isShowDetailDia = true;
    },
    // 移除
    yichu(row) {
      if (this.selectTableData.length == 0) {
        this.$message.warning("请选择一条记录进行操作");
        return;
      }
      this.$confirm("确认把所选数据移除？", "提示:")
        .then(async (res) => {
          this.selectTableData[0].operationType = "DEL";
          await this.$API.setOnwayDept({
            dispatchId: this.dispatchId,
            deptInfos: [this.selectTableData[0]],
          });
          this.tableData = this.tableData.filter(
            (item) => item.operationType !== "DEL"
          );
          this.getData({ dispatchId: this.dispatchId });
          this.$refs.mytable.clearSelection();
        })
        .catch();
    },
    // 上移
    async moveUp(row) {
      if (this.selectTableData.length != 1) {
        this.$message.warning("请选择一条记录进行操作");
        return;
      }
      row = this.selectTableData[0];
      const pos = this.getRowIndex(row);
      if (pos === 0) {
        this.$message.warning("该记录已经是第一条了");
        return;
      }
      const rowPrev = this.tableData[pos - 1];
      const sort = row.sort;
      row.sort = rowPrev.sort;
      row.operationType = "UPDATE";
      rowPrev.sort = sort;
      rowPrev.operationType = "UPDATE";
      this.$refs.mytable.clearSelection();
      await this.$API.setOnwayDept({
        dispatchId: this.dispatchId,
        deptInfos: [rowPrev, row],
      });
      await this.getData({ dispatchId: this.dispatchId });
      this.$refs.mytable.clearSelection()
      this.$refs.mytable.selectRow(this.tableData[pos - 1]);
    },
    // 下移
    async moveDown(row) {
      if (this.selectTableData.length != 1) {
        this.$message.warning("请选择一条记录进行操作");
        return;
      }
      row = this.selectTableData[0];
      const pos = this.getRowIndex(row);
      if (
        pos ===
        this.tableData.filter((item) => item.operationType !== "DEL").length - 1
      ) {
        this.$message.warning("该记录已经是最后一条了");
        return;
      }
      const rowNext = this.tableData[pos + 1];
      const sort = row.sort;
      row.sort = rowNext.sort;
      row.operationType = "UPDATE";
      rowNext.sort = sort;
      rowNext.operationType = "UPDATE";
      this.$refs.mytable.clearSelection();
      await this.$API.setOnwayDept({
        dispatchId: this.dispatchId,
        deptInfos: [rowNext, row],
      });
      await this.getData({ dispatchId: this.dispatchId });
      this.$refs.mytable.clearSelection()
      this.$refs.mytable.selectRow(this.tableData[pos + 1]);
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia(a) {
      this.isShowDialog = false;
      this.tableData = [];
      this.selectTableData = [];
    },
    //  弹窗确认保存事件
    diaConfirmBtn(a) {
      this.isShowDialog = false;
      this.tableData = [];
      this.selectTableData = [];
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn(a) {
      this.isShowDialog = false;
    },
    changeDept() {
      const one = this.businessDepts.filter(
        (item) => item.deptId === this.detailForm.deptId
      )[0];
      this.detailForm.deptName = one.deptName;
    },
    changeUnLoadOperationType() {
      const one = this.operationTypes.filter(
        (item) => item.state === this.detailForm.unLoadOperationType
      );
      this.detailForm.unLoadOperationTypeShow = one.unLoadOperationTypeShow;
    },
  },
};
</script>

<style>
</style>